import { Media, createMedia } from './media'
import { ItemList, createItemList } from './itemList'

export interface Collection {
  id: string
  handle: string
  locale: string
  globalHandle: string
  pimSyncSourceDomain: string
  pimSyncSource?: string
  pimSyncSourceCollectionId?: string
  title?: string
  description?: string
  featuredMedia?: Media
  productLists: Array<ItemList>
  createdAt?: number
  updatedAt?: number
}

export interface CreateCollectionOptions {
  id?: string
  handle?: string
  locale?: string
  globalHandle?: string
  pimSyncSourceDomain?: string
  pimSyncSource?: string
  pimSyncSourceCollectionId?: string
  title?: string
  description?: string
  featuredMedia?: Media | null
  productLists?: Array<ItemList>
  createdAt?: number
  updatedAt?: number
}

export const createCollection = (obj: CreateCollectionOptions): Collection => {
  const { productLists, featuredMedia, ...rest } = obj

  const collection = {
    id: '',
    handle: '',
    locale: 'en-us',
    globalHandle: '',
    pimSyncSourceDomain: '',
    productLists: [] as ItemList[],
    featuredMedia: null as Media | null,
    ...rest
  }

  if (productLists && Array.isArray(productLists)) {
    collection.productLists = productLists.map(list => {
      return createItemList(list)
    })
  }

  if (featuredMedia) {
    collection.featuredMedia = createMedia(featuredMedia)
  }

  return collection as Collection
}
